import { KoyouKeiyakuTimeApi } from "@/api/KoyouKeiyakuTimeApi";
import { KoyouKeiyakuTime } from "@/types/KoyouKeiyaku";
import { KoyouKeiyakuTimeAndHayabanOsobanOptions, KoyouKeiyakuTimeAndHayabanOsobanReq, KoyouKeiyakuTimeOptions, KoyouKeiyakuTimeReq } from "@/types/KoyouKeiyakuTime";

export class KoyouKeiyakuTimeService {
  /**
   * 全就業場所一覧を取得します
   * @returns システム上の全ての就業場所一覧
   */
  public async getByKoyouKeiyakuId(koyouKeiyakuId: number | null): Promise<KoyouKeiyakuTime[]> {
    const api = new KoyouKeiyakuTimeApi();
    const req: KoyouKeiyakuTimeReq = {
      koyouKeiyakuId,
      date: null
    }
    try {
      return await api.getByKoyouKeiyakuId(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 全就業場所一覧を取得します（オプション値）
   * @returns システム上の全ての就業場所一覧
   */
  public async getOptionsByKoyouKeiyakuId(koyouKeiyakuId: number | null): Promise<KoyouKeiyakuTimeOptions[]> {
    const api = new KoyouKeiyakuTimeApi();
    const req: KoyouKeiyakuTimeReq = {
      koyouKeiyakuId,
      date: null
    }
    try {
      return await api.getOptionsByKoyouKeiyakuId(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの就業場所を取得します
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getByKoyouKeiyakuIdAndDate(koyouKeiyakuId: number | null, date: null | string | Date): Promise<KoyouKeiyakuTime[]> {
    const api = new KoyouKeiyakuTimeApi();
    const req: KoyouKeiyakuTimeReq = {
      koyouKeiyakuId,
      date
    }
    try {
      return await api.getByKoyouKeiyakuIdAndDate(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの就業場所を取得します（オプション値）
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getOptionsByKoyouKeiyakuIdAndDate(koyouKeiyakuId: number | null, date: null | string | Date): Promise<KoyouKeiyakuTimeOptions[]> {
    const api = new KoyouKeiyakuTimeApi()
    const req: KoyouKeiyakuTimeReq = {
      koyouKeiyakuId,
      date
    }
    try {
      return await api.getOptionsByKoyouKeiyakuIdAndDate(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの就業場所を取得します（オプション値）
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate(koyouKeiyakuId: number | null, date: null | string | Date): Promise<KoyouKeiyakuTimeOptions[]> {
    const api = new KoyouKeiyakuTimeApi()
    const req: KoyouKeiyakuTimeReq = {
      koyouKeiyakuId,
      date
    }
    try {
      return await api.getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの就業場所を取得します（オプション値）
   * @returns 当該ユーザーの就業場所一覧
   */
  public async getOptionsAndHayabanOsobanByKoyouKeiyakuId(koyouKeiyakuId: number | null, userId: number | null, date: string | Date | null): Promise<KoyouKeiyakuTimeAndHayabanOsobanOptions> {
    const api = new KoyouKeiyakuTimeApi()
    const req: KoyouKeiyakuTimeAndHayabanOsobanReq = {
      koyouKeiyakuId,
      userId,
      date
    }
    try {
      return await api.getOptionsAndHayabanOsobanByKoyouKeiyakuId(req);
    } catch (e) {
      throw e;
    }
  }
}
